// Resolved through webpack so the hashed, pack-served URL is used (images no longer live under /assets).
const colorImages = require.context('../../../images/colors', false, /\.png$/);

$(() => {
  
  function colorSelectionFormatter(color, container){
    if (color.id == "") return color.text;
    return "<img style='background-color: #"+color.id+"' class='league-color' src='"+colorImages('./'+color.id+'.png')+"' /> "+ color.text;
  }

  $("#league_color").select2({
      placeholder: "Choose...",
      formatResult: colorSelectionFormatter,
      formatSelection: colorSelectionFormatter,
      escapeMarkup: function(m) { return m; },      
  });
  
});